<!-- <div id="particles-js">
  <particles [params]="myParams" [style]="myStyle"></particles>
</div> -->
<div class="d-none d-md-block">
  <visitor-desktop-home-screen></visitor-desktop-home-screen>
</div>

<div class="d-block d-md-none" >
  <visitor-mobile-home-screen></visitor-mobile-home-screen>
</div>